module.exports = __webpack_public_path__ + "static/media/plywood-furniture.8932ca1d.jpg";